import { TgsArticleImage } from '~/common/components/ArticleImage';
import type { AghArticle } from '~/common/types/aghArticle';
import { ArticlePrice } from '~/features/catalog/components/article/ArticlePrice';
import { cn } from '~/common/utils/styleUtil';
import { useCatalogAghArticle } from '~/features/catalog/hooks/useCatalogAghArticle';
import { ArticleSecondaryText } from '~/features/catalog/components/article/ArticleSecondaryText.tsx';
import ArticleAghInfoIcons from '~/features/catalog/components/ArticleAghInfoIcons.tsx';

export function QuickSearchAghArticleItem({
  article,
  onClick,
  selectedArticleNumber,
  isAuthenticated
}: Readonly<{
  article: AghArticle;
  onClick: (artNo: string) => void;
  selectedArticleNumber?: string;
  isAuthenticated: boolean;
}>) {
  const catalogArticle = useCatalogAghArticle(article, 1, selectedArticleNumber);
  return (
    <article
      className={cn(
        'group border-b desktop:border-b-0 border-r-0 p-4 xl:pl-4 hover:bg-neutral-50 h-full flex flex-col'
      )}
    >
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
      <div
        id={catalogArticle.articleNumber}
        onClick={() => onClick(catalogArticle.articleNumber)}
        className="flex flex-col flex-nowrap gap-4 cursor-pointer items-stretch cursor-pointer h-full"
      >
        <div className="flex gap-4 item-center">
          <TgsArticleImage
            articleNumber={catalogArticle.articleNumber}
            celumId={catalogArticle.celumId}
            alt={catalogArticle.description}
            size={'small'}
          />
          <div className={'flex flex-col items-start'}>
            <ArticlePrice
              showOnlyActionPrice={true}
              price={catalogArticle.price}
              oldPrice={catalogArticle.oldPrice}
              isAction={catalogArticle.isAction}
              actionValidFrom={catalogArticle.actionValidFrom}
              actionValidTo={catalogArticle.actionValidTo}
              unitText={catalogArticle.unitText}
              className={'my-0.5'}
              isHit={catalogArticle.isHit}
            />

            <h2
              className={cn(
                'text-base font-bold line-clamp-2 text-align-left',
                catalogArticle.isAction && !catalogArticle.isFutureAction && !catalogArticle.isHit && 'text-primary'
              )}
            >
              {catalogArticle.description}
            </h2>
            <ArticleSecondaryText
              articleNumber={catalogArticle.articleNumber}
              rohstoffHerkunft={catalogArticle.rohstoffHerkunft}
              brand={catalogArticle.brand}
              lineClamp={1}
            />
            <ArticleAghInfoIcons article={catalogArticle} className={'flex py-1'} isAuthenticated={isAuthenticated} />
          </div>
        </div>
      </div>
    </article>
  );
}
